export default "__VITE_ASSET__DmpnbQyq__"